
import React from 'react';
import { Control } from 'react-hook-form';
import { FormCard } from '../ui/FormCard';
import { GrossIncomeField } from './income/GrossIncomeField';
import { DeductionsFields } from './income/DeductionsFields';
import { EstimateDeductionsButton } from './income/EstimateDeductionsButton';

interface IncomeSectionProps {
  control: Control<any>;
  applicantStatus: string;
}

export function IncomeSection({ control, applicantStatus }: IncomeSectionProps) {
  return (
    <>
      <FormCard 
        title="Income Details" 
        description={applicantStatus === 'couple' 
          ? "Enter your combined household income (both you and your spouse/partner)" 
          : "Enter your total gross income from all sources"
        }
      >
        <div className="space-y-4">
          <GrossIncomeField control={control} applicantStatus={applicantStatus} />
        </div>
      </FormCard>

      <FormCard 
        title="Allowable Deductions" 
        description={
          <div className="flex items-center justify-between">
            <span>These expenses reduce your assessable income under Fair Deal</span>
            <EstimateDeductionsButton />
          </div>
        }
      >
        <DeductionsFields control={control} />
      </FormCard>
    </>
  );
}
